export default __webpack_public_path__ + "static/media/favicon2.6ccecf99.ico";